const INSTALLMENT_TYPES_PECUNIARY = {
  FIXED_PER_PERIOD: 'Parcelas fixas',
  VARIABLE_PER_PERIOD: 'Parcelas variáveis',
  PAID_BY_SPECIFIC_DATE: 'A ser pago até uma determinada data',
};

const INSTALLMENT_TYPES_COMPENSATION_TO_VICTIM = {
  FIXED_PER_PERIOD: 'Parcelas fixas',
  VARIABLE_PER_PERIOD: 'Parcelas variáveis',
  PAID_BY_SPECIFIC_DATE: 'A ser pago até uma determinada data',
};

const INSTALLMENT_TYPES_SERVICE = {
  FIXED_PER_PERIOD: 'Horas fixas por período',
  VARIABLE_PER_PERIOD: 'Horas variáveis por período',
  PAID_BY_SPECIFIC_DATE: 'A ser cumprido até uma determinada data',
};

export const INSTALLMENT_TYPES = {
  PECUNIARY: INSTALLMENT_TYPES_PECUNIARY,
  COMPENSATION_TO_VICTIM: INSTALLMENT_TYPES_COMPENSATION_TO_VICTIM,
  SERVICE: INSTALLMENT_TYPES_SERVICE,
}